import './bootstrap';
import $, { ajax } from 'jquery';

window.$ = window.jQuery = $;

import 'bootstrap-3-typeahead';

import Alpine, { start } from 'alpinejs';
import 'flowbite';
import 'aos/dist/aos.css';
import AOS from 'aos';
import { jarallax } from 'jarallax';
// import 'bootstrap-3-typeahead';
import '@fortawesome/fontawesome-free/js/all.js';

import EasyMDE from "easymde";
window.EasyMDE = EasyMDE;
import "easymde/dist/easymde.min.css";

import hljs from "highlight.js";
window.hljs = hljs;
import "highlight.js/styles/github.css";

// Swiper
// Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectCards, EffectCube, EffectFade, EffectCoverflow, EffectCreative } from 'swiper/modules';

// Import des styles nécessaires
import 'swiper/swiper-bundle.css';

window.Alpine = Alpine;
// init Swiper:
const swiper = new Swiper('.swiper', {
    // configure Swiper to use modules
    loop: true,
    speed: 400,
    effect: 'cards',
    autoplay: {
        delay: 4000,
    },
    spaceBetween: 100,
    modules: [Navigation, Pagination, Autoplay, EffectCards],
});

const swiperPortfolio = new Swiper('.swiper-portfolio', {
    // configure Swiper to use modules
    loop: true,
    speed: 600,
    effect: 'coverflow',
    autoplay: {
        delay: 3000,
    },
    spaceBetween: 30,
    slidesPerView:1,
    breakpoints:{
        640:{
            slidesPerView:2,
        },
        1024:{
            slidesPerView:3,
        }
    },
    navigation:{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    modules: [Navigation, Pagination, Autoplay, EffectCoverflow],
});

const swiperQoute = new Swiper('.swiper-quote',{
    loop: true,
    autoplay:{
        delay:3000,
    },
    effect: 'slide',
    spaceBetween: 30,
    slidesPerView:1,
    breakpoints:{
        640:{
            // effect:'cards',
            slidesPerView:2
        }
    },
    parallax:true,
    navigation:{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    modules: [Navigation, Pagination, Autoplay],
});

jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.2,
});

Alpine.start();

AOS.init({
    duration: 800, // Durée des animations en millisecondes
    once: false,     // Si `true`, l'animation se joue une seule fois
});

$.ajaxSetup({
    headers:{
        'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content'),
    },
});
